import Swiper from "swiper"

import { Navigation, Pagination, Controller, EffectFade } from "swiper/modules"

import "swiper/css"
import "swiper/css/effect-fade"

function caseStudyCarousel(el: HTMLElement) {
  const imageCarousel = el.querySelector<HTMLDivElement>(
    ".swiper.image-carousel",
  )
  const cardCarousel = el.querySelector<HTMLDivElement>(".swiper.card-carousel")
  const nextButton = el.querySelector<HTMLButtonElement>(".swiper-button-next")
  const prevButton = el.querySelector<HTMLButtonElement>(".swiper-button-prev")
  const pagination = el.querySelector<HTMLButtonElement>(".swiper-pagination")
  const controls = el.querySelector<HTMLButtonElement>(".controls")

  if (!imageCarousel || !cardCarousel) {
    return
  }

  const imageCarouselSwiper = new Swiper(imageCarousel, {
    centeredSlides: true,
    slidesPerView: 1,
    spaceBetween: 0,
    setWrapperSize: true,
    autoHeight: true,
    allowTouchMove: false,
    effect: "fade",
    fadeEffect: {
      crossFade: true,
    },
    modules: [EffectFade],
  })

  const cardCarouselSwiper = new Swiper(cardCarousel, {
    centeredSlides: true,
    slidesPerView: 1,
    spaceBetween: 132,
    speed: 1000,
    autoHeight: false,
    grabCursor: true,
    pagination: {
      el: pagination,
      clickable: true,
    },
    navigation: {
      nextEl: nextButton,
      prevEl: prevButton,
    },
    controller: {
      control: imageCarouselSwiper,
    },
    modules: [Navigation, Pagination, Controller],
  })
  if (cardCarouselSwiper.isLocked) {
    controls?.classList.add("hidden")
  }

  cardCarouselSwiper.on("lock", () => {
    controls?.classList.add("hidden")
  })

  cardCarouselSwiper.on("unlock", () => {
    controls?.classList.remove("hidden")
  })
}

export default caseStudyCarousel
